import { useQuery, useQueryCache } from "react-query";
import axios from '../../axiosWrapper'
import { query } from '../../util/config'

export default function useTemplates() {
  const cache = useQueryCache();
  const templates = cache.getQueryData(["templates"]);
  return useQuery(
    ["templates"],
    () => templates || [],//axios.get('templates'),
    query.initialQuery
  )
}